import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { AppState } from '../../../app/app.global';
import { Geolocation } from '@ionic-native/geolocation';


@Component({
  selector: 'page-geolocation',
  templateUrl: 'geolocation.html',
})
export class GeolocationPage {

  site:any;
  constructor(public navCtrl: NavController	,public global: AppState,private geolocation: Geolocation) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad GeolocationPage');
  }

  getlocal(){
  	this.geolocation.getCurrentPosition().then((resp) => {
  		console.log(resp);
			this.site = JSON.stringify(resp);
		 // resp.coords.latitude
		 // resp.coords.longitude
		}).catch((error) => {
		  console.log('Error getting location', error);
		});
		let watch = this.geolocation.watchPosition();
			watch.subscribe((data) => {
			this.site =  JSON.stringify(data);
			console.log(data);
		 	// data can be a set of coordinates, or an error (if an error occurred).
		 	// data.coords.latitude
		 	// data.coords.longitude
		});
  }




}



// WEBPACK FOOTER //
// ./src/pages/test/geolocation/geolocation.ts